module.exports = __webpack_public_path__ + "static/media/logo2.fb7239c4.png";